<mat-card>
  <app-card-header [title]="title" [icon]="icon" />

  <mat-card-content *ngIf="!loading && !isServerError">
    <mat-table [dataSource]="dataSource" class="recently-accepted-table">
      <ng-container matColumnDef="name">
        <mat-cell *matCellDef="let element">
          <div>
            <div class="d-flex align-items-center">
              {{ getRowTypeName(element.type).title }}
              <span class="question-icon" [matTooltip]="getRowTypeName(element.type).description">?</span>
            </div>
            <div class="mt-05 d-not-phone-none">
              <span *ngIf="element.description">{{ element.description }}</span>
              <span *ngIf="!element.description && element.type != BillingTableRowType.CurrentBalance" [ngTemplateOutlet]="emptyFieldText"></span>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="balance">
        <mat-cell *matCellDef="let element" class="balance-td">
          <div>
            <span *ngIf="element.balance; else emptyFieldText">
              <span *ngIf="element.isInFavourBalance != null"
                [ngClass]="element.type == BillingTableRowType.CurrentBalance ? (element.isInFavourBalance ? 'inFavour inline' : 'inDebt inline') : ''">
                {{ convertBalanceValue(element.balance) }} {{currencyName}} <span
                  *ngIf="element.type == BillingTableRowType.CurrentBalance"
                  [ngClass]="element.type == BillingTableRowType.CurrentBalance ? (element.isInFavourBalance ? 'inFavour inline' : 'inDebt inline') : ''">
                  {{element.isInFavourBalance && element.type== BillingTableRowType.CurrentBalance ? element.inFavourText :
                  element.inDebtText}}</span>
              </span>
              <span *ngIf="element.isInFavourBalance == null">{{ convertBalanceValue(element.balance) }} {{currencyName}}</span>
            </span>
            <div class="mt-05 d-not-phone-none">
              <div *ngIf="element.type === BillingTableRowType.NextVoucher">
                <span *ngIf="element.date; else emptyFieldText">
                  <strong>{{ element.date }}</strong>
                </span>
              </div>
              <div *ngIf="element.type === BillingTableRowType.LastPaymentMade">
                <span *ngIf="element.date; else emptyFieldText">
                  <div class="d-flex align-items-center">
                    <mat-icon [svgIcon]="'check'" class="square-icon check-icon"></mat-icon>
                    <div>{{ element.date }}</div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="description">
        <mat-cell *matCellDef="let element" class="d-phone-none description-td">
          <span *ngIf="element.description">{{ element.description }}</span>
          <span *ngIf="!element.description && element.type != BillingTableRowType.CurrentBalance" [ngTemplateOutlet]="emptyFieldText"></span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="date">
        <mat-cell *matCellDef="let element" class="date-td d-phone-none">  
          <div *ngIf="element.type === BillingTableRowType.NextVoucher">
            <span *ngIf="element.date; else emptyFieldText"><strong>{{ element.date }}</strong></span>
          </div>
          <div *ngIf="element.type === BillingTableRowType.LastPaymentMade">
            <span class="d-flex align-items-center" *ngIf="element.date; else emptyFieldText">
              <mat-icon [svgIcon]="'check'" class="square-icon check-icon"></mat-icon>
              <span><span>{{ element.date }} </span></span>
            </span>
          </div>    
        </mat-cell>
      </ng-container>

      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <p class="table-description">{{footnoteText}}</p>
  </mat-card-content>

  <mat-card-content *ngIf="loading && !isServerError">
      <div class="preloader--mini">
          <div class="preloader__icon">
              <img alt="" height="50" loading="lazy" src="Content/Images/icons/preloader.png?format=webp" width="50">
            </div>
      </div>
  </mat-card-content>

  <mat-card-content *ngIf="isServerError">
    <app-timeout-error-message></app-timeout-error-message>
  </mat-card-content>
</mat-card>

<ng-template #emptyFieldText>
  <span><strong>-</strong></span>
</ng-template>